import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';
import './ValidarCertificado.css';

const ValidarCertificado = () => {
  const { uuid } = useParams();
  const [loading, setLoading] = useState(true);
  const [dados, setDados] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    if (uuid) {
      validarCertificado();
    }
  }, [uuid]);

  const validarCertificado = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await api.get(`/certificados/validar/${uuid}?formato=json`);
      
      if (response.data.success) {
        setDados(response.data);
      } else {
        setError(response.data.motivo || 'Erro ao validar certificado');
      }
    } catch (err) {
      setError(err.response?.data?.motivo || 'Erro ao validar certificado');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="validar-container">
        <div className="validar-loading">
          <p>Validando certificado...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="validar-container">
      <div className="validar-card">
        {error ? (
          <div className="validar-resultado invalido">
            <div className="resultado-icon">❌</div>
            <h1>Certificado Inválido</h1>
            <p className="motivo">{error}</p>
          </div>
        ) : dados?.valido ? (
          <div className="validar-resultado valido">
            <div className="resultado-icon">✅</div>
            <h1>Certificado Válido</h1>
            
            <div className="validar-info">
              <div className="info-section">
                <h3>Informações do Titular</h3>
                <div className="info-item">
                  <span className="label">Nome:</span>
                  <span className="value">{dados.titular?.nome || 'N/A'}</span>
                </div>
                <div className="info-item">
                  <span className="label">Email:</span>
                  <span className="value">{dados.titular?.email || 'N/A'}</span>
                </div>
              </div>

              <div className="info-section">
                <h3>Detalhes do Certificado</h3>
                <div className="info-item">
                  <span className="label">Número de Série:</span>
                  <span className="value">{dados.numero_serie}</span>
                </div>
                <div className="info-item">
                  <span className="label">Status:</span>
                  <span className={`value status ${dados.status}`}>
                    {dados.status === 'ativo' ? 'Ativo' : dados.status}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Data de Emissão:</span>
                  <span className="value">
                    {new Date(dados.data_emissao).toLocaleString('pt-BR')}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Data de Expiração:</span>
                  <span className="value">
                    {new Date(dados.data_expiracao).toLocaleString('pt-BR')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="validar-resultado invalido">
            <div className="resultado-icon">⚠️</div>
            <h1>Certificado Não Encontrado</h1>
            <p className="motivo">O certificado com UUID {uuid} não foi encontrado no sistema.</p>
          </div>
        )}

        <div className="validar-footer">
          <p>DocLine - Sistema de Certificação Digital</p>
          <a href="/">Voltar ao sistema</a>
        </div>
      </div>
    </div>
  );
};

export default ValidarCertificado;

